<template>
  <div class="point-course" @click="handleBuyBtnClick">
    <img :src="imagePath" />
    <div class="value" v-if="pointPriceItem.price > pointPriceItem.discount">
      <span>¥</span>{{pointPriceItem.discount | comma}}
      <span class="doller">(${{ pointPriceItem.discount_doller | commma }})</span>
    </div>
    <div class="value" v-else>
      <span>¥</span>{{pointPriceItem.price | comma}}
      <span class="doller">(${{ pointPriceItem.doller | commma }})</span>
    </div>
    <!-- <SquareButton
      text="BUY"
      class="square-button"
      @handleSquareBtnClick="handleBuyBtnClick"
    /> -->
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';

import t from '@/plugins/i18n';

export default {
  name: 'PointCourse',
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },

  props: {
    pointPriceItem: {
      type: Object,
    },
    // point: {
    //   type: String,
    // },
    // price: {
    //   type: String,
    // },
    // doller: {
    //   type: String,
    // },
    // memo: {
    //   type: String,
    // },
  },

  computed: {
    bonusPoint() {
      const bonusPoint = parseInt(this.pointPriceItem.point, 10) - parseInt(this.pointPriceItem.price, 10);
      return separateCharacterNumber(bonusPoint);
    },
    imagePath() {
      return `/img/buypoint/${this.pointPriceItem.point}.png`;
    },
  },

  methods: {
    handleBuyBtnClick() {
      this.$emit('handleBuyBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.point-course{
  text-align: left;
  width: 140px;
  margin: 5px;
  position: relative;
  cursor: pointer;
  @media screen and  (max-width: $tabletWidth) {
    width: 140px;
    margin: 5px 5px;
  }
  img {
    width: 100%;
  }
  .value {
    color: #fff;
    font-weight: bold;
    position: absolute;
    bottom: 14px;
    left: 0px;
    width: 100%;
    text-align: center;
    @media screen and  (max-width: $tabletWidth) {
      bottom: 16px;
      font-size: 90%;
    }
  }

  .shadow-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 10px;
    font-family: $notoSans;
    font-size: 20px;
    flex-wrap: wrap;
    .point-area{
      display: flex;
      flex-wrap: wrap;
      margin-left: 20px;
      .point{
        font-weight: 700;
        line-height: 29px;
        color: $white;
        &:after {
          content: " Gem";
        }
      }
      .point-service{
        font-size: 12px;
      }
    }
    .value{
      margin-left: auto;
      color: $white;
      margin-right: 20px;
      .doller {
        font-size: 70%;
      }
    }
    .square-button{
      width: 100px;
      height: 36px;
    }
  }
}
.memo {
  width: 100%;
  margin-left: 40px;
  font-size: 12px;
  color: $red;
}
// @media screen and  (max-width: $tabletWidth) {
//   .point-course{
//     width: 100%;
//     .shadow-box {
//       font-size: 16px;
//       padding: 10px 0;
//       .square-button{
//         margin-right: 5px;
//       }
//     }
//   }
// }
</style>
